import { emailReg, idCardReg, phoneReg } from './reg';
/** 小表单 */
export var COLLECT_CONFIG = [
    {
        key: 'pc',
        name: 'PC表单',
        projectKeys: ['4399yy', 'zhkf'],
        fields: [
            {
                key: 'game_name',
                label: '游戏名称',
                placeholder: '请输入游戏名称',
                require: true,
                length: 50
            },
            { key: 'account', label: '账号', placeholder: '请输入账号', require: true, length: 20 },
            { key: 'server', label: '区服', placeholder: '请输入区服', require: true, length: 20 },
            {
                key: 'role',
                label: '角色名',
                placeholder: '请输入角色名',
                require: true,
                length: 20
            },
            {
                key: 'contact',
                label: '联系方式',
                placeholder: '请输入邮箱或手机号',
                require: true,
                length: 30
            }
        ]
    },
    {
        key: 'xcx',
        name: '小程序表单',
        projectKeys: ['xcx'],
        fields: [
            {
                key: 'game_name',
                label: '游戏名称',
                placeholder: '请输入游戏名称',
                require: true,
                length: 50
            },
            { key: 'server', label: '区服', placeholder: '请输入区服', require: true, length: 20 },
            {
                key: 'role',
                label: '角色名',
                placeholder: '请输入角色名',
                require: true,
                length: 20
            },
            {
                key: 'role_id',
                label: '角色ID',
                placeholder: '请输入角色ID',
                require: true,
                length: 50
            },
            {
                key: 'contact',
                label: '联系方式',
                placeholder: '请输入邮箱或手机号',
                require: true,
                length: 30
            }
        ]
    },
    {
        key: 'yxd',
        name: '游戏店表单',
        projectKeys: ['yxd'],
        fields: [
            { key: 'real_name', label: '实名姓名', placeholder: '请输入账号实名姓名', length: 50 },
            {
                key: 'id_card',
                label: '身份证号',
                placeholder: '请输入账号实名身份证号',
                length: 50,
                rules: [
                    {
                        pattern: idCardReg,
                        message: '请输入正确的身份证号'
                    }
                ]
            },
            {
                key: 'phone',
                label: '手机号码',
                placeholder: '请输入账号绑定的手机号',
                length: 30,
                rules: [
                    {
                        pattern: phoneReg,
                        message: '请输入正确的手机号'
                    }
                ]
            },
            {
                key: 'bank_card',
                label: '银行卡号',
                placeholder: '请输入账号绑定的银行卡号',
                length: 20
            },
            {
                key: 'bank_name',
                label: '开户行',
                placeholder: '请输入银行卡开户行',
                length: 50
            },
            {
                key: 'history_amount',
                label: '充值金额',
                placeholder: '请输入账号历史充值金额',
                length: 50
            },
            {
                key: 'order_no',
                label: '充值订单号',
                placeholder: '请填写金额较大的一个',
                length: 50
            },
            {
                key: 'contact',
                label: '联系邮箱',
                placeholder: '请输入联系邮箱',
                length: 30,
                rules: [
                    {
                        pattern: emailReg,
                        message: '请输入正确的邮箱号'
                    }
                ],
                require: true
            }
        ],
        greeting: '为了您的账号安全，我们需要进行账号所有权验证。'
    }
    // {
    //     key: '4399sy', // 手游
    //     name: '小程序表单',
    //     fields: [
    //         {
    //             key: 'game_name',
    //             label: '游戏名称',
    //             placeholder: '请输入游戏名称',
    //             require: true,
    //             length: 50
    //         },
    //         { key: 'server', label: '区服', placeholder: '请输入区服', require: true, length: 20 },
    //         {
    //             key: 'role',
    //             label: '角色名',
    //             placeholder: '请输入角色名',
    //             require: true,
    //             length: 20
    //         },
    //         {
    //             key: 'role_id',
    //             label: '角色ID',
    //             placeholder: '请输入角色ID',
    //             require: true,
    //             length: 50
    //         },
    //         {
    //             key: 'contact',
    //             label: '联系方式',
    //             placeholder: '请输入邮箱或手机号',
    //             require: true,
    //             length: 30
    //         }
    //     ]
    // }
];
export var getCollectConfig = function (collectType) {
    return COLLECT_CONFIG.find(function (item) {
        return item.key === collectType ||
            (collectType ? item.projectKeys.includes(collectType) : false);
    });
};
